import moment from "moment";
const defaultFilters = {
  fromCreateDateTime: moment().subtract(1, "W").format("YYYY-MM-DD"),
  toCreateDateTime: moment().format("YYYY-MM-DD"),
  fromYear: moment().subtract(1, "Y").format("YYYY"),
  toYear: moment().format("YYYY"),
  paymentType: 1,
  IsVisible: false,
  machineName: null,
  productType: 1
};
export default function getDefaultFilters (filterName = "general") {
  try {
    switch (filterName) {
      case "general": {
        const filter = JSON.parse(
          localStorage.getItem("statFilters")
        ).generalSalesChartFilter;
        return {
          ...defaultFilters,
          paymentType: filter?.paymentType,
          IsVisible: filter?.IsVisible,
        };
      }
      case "period": {
        const filter = JSON.parse(
          localStorage.getItem("statFilters")
        ).periodSellFilter;
        return {
          ...defaultFilters,
          paymentType: filter?.paymentType,
          IsVisible: filter.IsVisible,
          toCreateDateTime: moment(defaultFilters).format("YYYY-MM"),
          fromCreateDateTime: null,
        };
      }
      // case "yearToYear":
      case "yearToYearMachinesSalesFilter": {
        const filter = JSON.parse(
          localStorage.getItem("statFilters")
        ).yearToYearMachinesSalesFilter;
        return {
          ...defaultFilters,
          paymentType: null,
          IsVisible: filter?.IsVisible,
        };
      }
      case "yearToYearProductsSalesFilter": {
        const filter = JSON.parse(
          localStorage.getItem("statFilters")
        ).yearToYearProductsSalesFilter;
        return {
          ...defaultFilters,
          productType: 1,
          IsVisible: filter?.IsVisible,
        };
      }
      case "sellData": {
        const filter = JSON.parse(
          localStorage.getItem("statFilters")
        ).sellDataFilter;
        return {
          ...defaultFilters,
          paymentType: filter?.paymentType,
          IsVisible: filter?.IsVisible,
        };
      }
      case "showMachinesStat": {
        const filter = JSON.parse(
          localStorage.getItem("statFilters")
        )?.showMachinesStat;
        return filter ?? false;
      }
      case "showProductsStat": {
        const filter = JSON.parse(
          localStorage.getItem("statFilters")
        )?.showProductsStat;
        return filter ?? false;
      }
      case "showYearMachinesStat": {
        const filter = JSON.parse(
          localStorage.getItem("statFilters")
        )?.showYearMachinesStat;
        return filter ?? false;
      }
      default:
        return defaultFilters;
    }
  } catch (e) {
    console.log(e);
    return defaultFilters;
  }
};
